// src/components/FloatingBulkBar.jsx — Bottom-center floating bulk action bar
import React, { useState } from 'react';
import { UserCheck, Tag, Sparkles, MessageSquare, Download, Trash2, X } from 'lucide-react';
import { AgentPopover, StatusPopover, BrandPopover } from './LeadPopovers';

export default function FloatingBulkBar({
  selectedCount,
  onClearSelection,
  onBulkAgent,
  onBulkStatus,
  onBulkBrand,
  onBulkWhatsApp,
  onBulkExport,
  onBulkDelete,
  agents,
  statuses,
  brands,
}) {
  const [activePopover, setActivePopover] = useState(null); // 'agent' | 'status' | 'brand' | null

  if (selectedCount === 0) return null;

  return (
    <div className="floating-bulk-bar">
      <div className="floating-bulk-bar__count">
        <span className="count-badge">{selectedCount}</span>
        <span>{selectedCount === 1 ? 'lead selected' : 'leads selected'}</span>
      </div>

      <div className="floating-bulk-bar__divider" />

      <div className="floating-bulk-bar__actions">
        {/* Assign Agent */}
        <div className="bulk-popover-wrapper">
          <button
            type="button"
            className="bulk-btn"
            onClick={() => setActivePopover(activePopover === 'agent' ? null : 'agent')}
          >
            <UserCheck size={14} /> Assign Agent
          </button>
          {activePopover === 'agent' && (
            <AgentPopover
              currentAgentId=""
              agents={agents}
              onSelect={(agentId, agentName) => {
                onBulkAgent(agentId, agentName);
                setActivePopover(null);
              }}
              onClose={() => setActivePopover(null)}
            />
          )}
        </div>

        {/* Set Status */}
        <div className="bulk-popover-wrapper">
          <button
            type="button"
            className="bulk-btn"
            onClick={() => setActivePopover(activePopover === 'status' ? null : 'status')}
          >
            <Tag size={14} /> Set Status
          </button>
          {activePopover === 'status' && (
            <StatusPopover
              currentStatus=""
              options={statuses}
              onSelect={(status) => {
                onBulkStatus(status);
                setActivePopover(null);
              }}
              onClose={() => setActivePopover(null)}
            />
          )}
        </div>

        {/* Set Brand */}
        <div className="bulk-popover-wrapper">
          <button
            type="button"
            className="bulk-btn"
            onClick={() => setActivePopover(activePopover === 'brand' ? null : 'brand')}
          >
            <Sparkles size={14} /> Set Brand
          </button>
          {activePopover === 'brand' && (
            <BrandPopover
              currentBrandId=""
              brands={brands}
              onSelect={(brandId, brandName) => {
                onBulkBrand(brandId, brandName);
                setActivePopover(null);
              }}
              onClose={() => setActivePopover(null)}
            />
          )}
        </div>

        {/* WhatsApp */}
        <button type="button" className="bulk-btn" onClick={onBulkWhatsApp}>
          <MessageSquare size={14} /> WhatsApp
        </button>

        {/* Export */}
        <button type="button" className="bulk-btn" onClick={onBulkExport}>
          <Download size={14} /> Export
        </button>

        {/* Delete */}
        <button type="button" className="bulk-btn bulk-btn--danger" onClick={onBulkDelete}>
          <Trash2 size={14} /> Delete
        </button>
      </div>

      <div className="floating-bulk-bar__divider" />

      {/* Clear selection */}
      <button
        type="button"
        className="bulk-btn-close"
        title="Clear selection"
        onClick={onClearSelection}
      >
        <X size={16} />
      </button>
    </div>
  );
}
